export const dataUsageArray = [
  {
    key: 'profile_information',
  },

  {
    key: 'game_library',
  },

  {
    key: 'playtime',
  },

  {
    key: 'inventory',
  },

  {
    key: 'privacy_first',
  },
]
